module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = 7
 ** module chunks = 0
 **/